<template>
<v-text-field
    hide-details
    append-icon="mdi-send"
    v-model="model"
    @click:append="$emit('submit')"
    @keypress.enter="$emit('submit')"
    placeholder="Comment"
    outlined
    dense
    shaped
    :loading="loading"
    :disabled="loading"
    class="mt-2">
</v-text-field>
</template>

<script>
export default {
    name: "CustomerActivityDisplayCommentEdit",
    data() {
        return {}
    },
    props: {
        value: String,
        loading: Boolean
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    }
}
</script>
